import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./components/Homepage/Homepage";
import PhilosophyAndSustainabilityPage from "./pages/PhilosophyAndSustainabilityPage";
import LoginAndAccountPage from "./pages/LoginAndAccountPage";
import ContactAndCustomerServicePage from "./pages/ContactAndCustomerServicePage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import CareersPage from "./pages/CareersPage";
import NewsLetterAndSharePage from "./pages/Newsletterandshare.jsx";
import NewsPage from "./pages/NewsPage";
import Login from "./components/LoginRegister/Login";
import Register from "./components/LoginRegister/Register";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import Admin from "./components/Admin/Admin.jsx";
import AdminProtectedRoute from "./components/AdminProtectedRoute.jsx";
import WebshoppWithPayPal from "./components/Webshop/WebshopWithPayPal.jsx";
import WebshopPaypalTestWithInbyggdCodeToStoreSubsIDtoSupabase from "./components/Webshop/WebshopPaypalTestWithInbyggdCodeToStoreSubsIDtoSupabase.jsx";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import UnderConPage from "./pages/UnderConstructionPage.jsx";

function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/register" element={<Register />} />
                        <Route path="/" element={<UnderConPage />} />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;
